<div class="tree-container">
  <!-- Flat -->
  <ng-container *ngIf="flatten">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="flat-tree">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding class="flat-node">
        <div class="key-value" *ngIf="!node.children">
          <p class="key">{{node.name}}: </p>
          <p class="value">{{node.value}}</p>
        </div>
      </mat-tree-node>
      <mat-tree-node #headerNode *matTreeNodeDef="let node; when: hasChild" class="nested-node" matTreeNodePadding>
        <div class="tree-node-wrapper">
          <div class="node-header" (click)="handleNodeClick(node)">
            <button mat-icon-button [attr.aria-label]="'toggle ' + node.name">
              <mat-icon>{{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}</mat-icon>
            </button>
            <div class="header-text">
              {{node.name}} {{_isArray(node.value) ? " - ("+node.value.length+")" : ''}}
            </div>
            <mat-icon *ngIf="_isArray(node.value)">format_list_numbered</mat-icon>
            <mat-icon *ngIf="!_isArray(node.value)">ballot</mat-icon>
          </div>
        </div>
        <div [class.tree-invisible]="!treeControl.isExpanded(node)" class="tree-padding">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-tree-node>
    </mat-tree>
  </ng-container>
  
  <!-- Nested -->
  <ng-container *ngIf="!flatten">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding class="tree-node">
        <div class="key-value" *ngIf="!node.children">
          <p class="key">{{node.name}}: </p>
          <p class="value">{{node.value}}</p>
        </div>
      </mat-tree-node>
      <mat-nested-tree-node #headerNode *matTreeNodeDef="let node; when: hasChild" class="nested-node">
        <div class="nested-tree-node-wrapper">
          <div (click)="handleNodeClick(node)" class="node-header">
            <button mat-icon-button [attr.aria-label]="'toggle ' + node.name">
              <mat-icon>{{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}</mat-icon>
            </button>
            <div *ngIf="node.children" class="header-text">{{node.name}}</div>
            
            <mat-icon *ngIf="_isArray(node.value)">format_list_numbered</mat-icon>
            <mat-icon *ngIf="!_isArray(node.value)">ballot</mat-icon>
          </div>
          <div [class.tree-invisible]="!treeControl.isExpanded(node)" class="tree-children">
            <ng-container matTreeNodeOutlet></ng-container>
          </div>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </ng-container>
</div>
  
  